import { useEffect, useState } from "react";
import Button from "../../../../components/Button";
import ButtonIcon from "../../../../components/ButtonIcon";
import { lang } from "../../../../functions/lang";
import ModalTitleText from "../../../usuario/components/ModalTitleText";
import RangeMoney from "../RangeMoney";
import styles from "./styles.module.css";

import { getUrls } from "../../../../services/wl/getUrls";
import IconBusiness from "../../../../components/Icon/IconBusiness";
import IconUser from "../../../../components/Icon/IconUser";
import Select2 from "../../../../components/Select/Select2";
import { handleFindOptionsMunicipios } from "../../../../functions/find-municipios";
import { configSimulacao } from "./configSimulacao";
import { findPlanosDescontos } from "./findPlanosDescontos";
import { getResultFailMessage } from "./getResultMessages";
import { getResultDiscountMessage } from "./getResultMessages";
import Router from "next/router";
import { getLead, saveLead } from "../../../../functions/leads";
import { COOKIES_TAGS } from "../../../../functions/cookies/COOKIES_TAGS";
import { deleteCookie, getCookie } from "cookies-next";
import ToggleButtons from "../../../../components/ToggleButtons";
import InputCard from "../../../../components/Input/InputCard";
import SelectUnstyled from "../../../../components/Select/SelectUnstyled";
import { formatBRL } from "../../../../functions/mask";
import IconCo2 from "../../../../components/Icon/IconCo2";
import IconPercent from "../../../../components/Icon/IconPercent";
import { use } from "react";
import { calcularCO2, calcularArvoresEquivalentes } from "../../../../functions/usinas/CalculoCo2";
import { calcularConsumoKwh } from "../../../../functions/usinas/CalcularConsumoKWH";

/**
 * Formulário da Calculadora
 *
 * - Campos adicionais poderão ser adicionados com prefixo "ef_": Extra Field.
 * Ex: `https://app.electy.com.br/calculadora-desconto?type=form&ef_campo1=123&ef_campo2=456`
 *
 * No exemplo temos os campos ef_campo1 e ef_campo2 adicionados e incorporados dinamicamente
 */
const Iframe = (props) => {
  // Valida se deve aparecer opções para selecionar "PF"|"PJ"
  const oneOptionContractEnabled =
    props.wl.Calculadora.habilitar_contrato_pf &&
    !props.wl.Calculadora.habilitar_contrato_pj
      ? "pf"
      : props.wl.Calculadora.habilitar_contrato_pj &&
        !props.wl.Calculadora.habilitar_contrato_pf
      ? "pj"
      : false;

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    valorConsumo: null,
    valorConta: null, // Valor da conta em centavos
    dataDiscount: "",
    dataConfigOfertas: null,
    selectedConcessionaria: null,
    submitButtonChildren: "Simular economia",
    errorMessage: "",
    concessionariasMunicipio: [],
    selectedTypeButton: {
      selected: "pf",
      pf: "selected",
      pj: "",
    },
  });
  const [dadosCalculoCo2, setDadosCalculoCo2] = useState({
    co2: null,
    arvores: null,
  });

  const [alturaInputCardMunicipio, setAlturaInputCardMunicipio] = useState(0);
  const [alturaInputCardConcessionaria, setAlturaInputCardConcessionaria] =
    useState(0);

  const handleSelectTipoPessoa = (type) => {
    setFormData({
      ...formData,
      selectedTypeButton: {
        pf: type === "pf" ? "selected" : "",
        pj: type === "pj" ? "selected" : "",
        selected: type,
      },
    });

    configSimulacao({
      setFormData,
      formData: {
        ...formData,
        selectedTypeButton: {
          pf: type === "pf" ? "selected" : "",
          pj: type === "pj" ? "selected" : "",
          selected: type,
        },
      },
      concessionariaId: selectedConcessionaria?.id,
    });
    setErrorMessage("");
  };


  useEffect(() => {

    if (selectedConcessionaria && formData?.valorConsumo && formData?.selectedTypeButton?.selected) {

      const consumoEmReais = formData?.valorConsumo;
      const valorKwh = formData?.selectedTypeButton?.selected === "pf" ?
        selectedConcessionaria?.valorKwhPf :
        selectedConcessionaria?.valorKwhPj;

      const consumoKwh = calcularConsumoKwh({consumoDinheiro :consumoEmReais , valorKwh});

      const co2 = calcularCO2(consumoKwh);
      const arvores = calcularArvoresEquivalentes(consumoKwh);

      setDadosCalculoCo2((prev) => ({
        ...prev,
        co2: co2 * 12, // Multiplicando por 12 para obter o valor anual
        arvores: Math.round(arvores * 12), // Multiplicando por 12 para obter o valor anual
      })
      )
    }

  }, [selectedConcessionaria, formData?.selectedTypeButton, formData?.valorConsumo]);

  const [selectedConcessionaria, setSelectedConcessionaria] = useState(null);
  // const enableSharp = props.infos.usa_sharpspring;
  const [submitButtonChildren, setSubmitButtonChildren] =
    useState("Simular economia");

  const [errorMessage, setErrorMessage] = useState("");
  const [concessionariasMunicipio, setConcessionariasMunicipio] = useState([]);

  // Cada campo não preenchido é recebido nessa função: Se algum estiver na lista de bloqueados, a chamada é interrompida
  const hasInvalidInputs = (e) => {
    if (e.target.getAttribute("name") == "tipoConta") {
      setErrorMessage("Selecione o tipo da conta!");
      return true;
    }
    if (e.target.getAttribute("name") == "concessionaria") {
      setErrorMessage("Selecione a concessionária!");
      return true;
    }

    return false;
  };


  const imgSplash = getUrls(props.wl?.splash?.data?.attributes?.url);

  const onSubmit = async (e) => {

    e.preventDefault();

    const formData = {};
    const formElements = e.target.elements;


    for (let element of formElements) {
      if (element.name) {
        formData[element.name] = element.value;
      }
    }

    let savedLead = {};
    try {
      const municipioEstado = formData.municipio?.split(" - ");
      const municipio = municipioEstado?.[0];
      const uf = municipioEstado?.[1];

      deleteCookie(COOKIES_TAGS.LEAD_ID);

      savedLead = await saveLead({
        assessor: formData.ef_assessor || formData.ef_parceiro,
        campanha: formData.representante,
        municipio: municipio,
        uf: uf,
        concessionaria: Number(formData.concessionaria),
        tipo: formData.tipoConta,
        valor_consumo: formData.money,
      });
    } catch (error) {
      console.log({ error });
    }

    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
    }, 10000);

    Router.push(`/form-dados-pessoais`);
    return;
  };

  const bgSubmitButton =
    submitButtonChildren != "Simular economia" || !formData?.dataDiscount.status
      ? { background: "#B6BEC9", color: "#fff", height: "42px", padding: "0 12px", minHeight: "unset",  marginTop: "10px" }
      : {
          color: props.wl?.cor_texto_botao || "#fff",
          background: props.wl?.cor_tema_botao_solido || "#26A150"
            ? props.wl?.cor_tema_botao_solido
            : "1",
          height: "42px",
          padding: "0 12px",
          minHeight: "unset",
          marginTop: "10px",
        };

  /**
   * Configura a option de concessionária para o Lead
   */
  const handleMunicipioChange = (_selectedMunicipio) => {
    const concessionariaOptions = [];
    _selectedMunicipio?.concessionarias?.map((concessionaria) => {

      concessionariaOptions.push({
        id: concessionaria.id,
        name: concessionaria.attributes.nome,
        label: concessionaria.attributes.nome,
        value: concessionaria.id,
        valorKwhPf: concessionaria.attributes?.valor_kwh_pf,
        valorKwhPj: concessionaria.attributes?.valor_kwh_pj

      });
    });

    setConcessionariasMunicipio(concessionariaOptions);

    if (concessionariaOptions.length < 2) {
      setSelectedConcessionaria(concessionariaOptions?.[0]);
      findPlanosDescontos({
        concessionariaId: concessionariaOptions?.[0]?.id,
      }).then((_dataConfigOfertas) => {
        setFormData({
          ...formData,
          dataConfigOfertas: _dataConfigOfertas,
        });

        configSimulacao({
          setFormData,
          formData: { ...formData, dataConfigOfertas: _dataConfigOfertas },
          concessionariaId: concessionariaOptions?.[0]?.id,
        });
      });
    }
  };

  const handleConcessionariaChange = (_selectedConcessionaria) => {
    setSelectedConcessionaria(_selectedConcessionaria);

    if (!_selectedConcessionaria || !_selectedConcessionaria.id) {
      // Não faz nada se não houver concessionária selecionada
      return;
    }

    findPlanosDescontos({ concessionariaId: _selectedConcessionaria.id }).then(
      (_dataConfigOfertas) => {
        setFormData({
          ...formData,
          dataConfigOfertas: _dataConfigOfertas,
        });

        configSimulacao({
          setFormData,
          formData: { ...formData, dataConfigOfertas: _dataConfigOfertas },
          concessionariaId: _selectedConcessionaria.id,
        });
      }
    );
  };

  if (isLoading) {
    return (
      <>
        <img
          className={styles.iconLoading}
          src={imgSplash}
          width={150}
          height={150}
        />
      </>
    );
  }

  const handleMenuOpen = (alturaInputCard, estadoSelect) => {
    if (estadoSelect === "open") {
      setAlturaInputCard(alturaInputCard);
    } else {
      setAlturaInputCard(0);
    }
  };

  const makeHandleMenuOpen = (setAltura) => (altura, estado) => {
    if (estado === "open") {
      setAltura(altura);
    } else {
      setAltura(0);
    }
  };

  const formProps = props.isApp
    ? {
        onSubmit: onSubmit,
        className: styles.form,
        onInvalid: hasInvalidInputs,
        method: "get",
      }
    : {
        className: styles.form,
        onInvalid: hasInvalidInputs,
        action: `${process.env.NEXT_PUBLIC_BASE_URL}/form-dados-pessoais`,
        target: "_blank",
        method: "get",
      };

  return (
    <>
      <form {...formProps} style={{ padding: "0 45px" }}>
        {props.extraFields.map((item) => (
          <input
            type="hidden"
            key={`INPUT__${item.key}`}
            name={item.key?.toLowerCase() ?? item.key}
            value={item.value}
          />
        ))}
        <input
          type="hidden"
          name="representante"
          value={props.owner ?? props.wl.campanha_default}
        />
        <input type="hidden" name="full" value={props.full ? "1" : ""} />
        <h3
          className={styles.title}
          style={{ color: props.wl?.cor_tema_primaria, textAlign: "left" }}
        >
          Encontre sua energia mais barata e limpa
        </h3>

        {!oneOptionContractEnabled && (
          <article className={styles["select-type"]}>
            <ToggleButtons
              txtButton1="Para minha casa"
              txtButton2="Para meu negócio"
              valueButton1="pf"
              valueButton2="pj"
              handleSelect={handleSelectTipoPessoa}
              wl={props.wl}
            />
          </article>
        )}

        {/* SELECT DE MUNICIPIOS */}
        <InputCard
          title={"Cidade"}
          name="municipio"
          style={{ marginTop: "18px", height: alturaInputCardMunicipio }}
          alturaMenuOpen={alturaInputCardMunicipio}
          wl={props.wl}
          component={
            <SelectUnstyled
              id="select"
              name="municipio"
              handleMenuOpen={makeHandleMenuOpen(setAlturaInputCardMunicipio)}
              required
              handleChange={handleMunicipioChange}
              placeholder="Busque por cidade"
              handleFindOptions={handleFindOptionsMunicipios}
              wl={props.wl}
            />
          }
        />
        {concessionariasMunicipio.length > 1 && (
          <InputCard
            title={"Concessionária"}
            alturaMenuOpen={alturaInputCardConcessionaria}
            wl={props.wl}
            component={
              <SelectUnstyled
                id="select-concessionaria"
                handleMenuOpen={makeHandleMenuOpen(setAlturaInputCardConcessionaria)}
                isSearchable={false}
                required
                placeholder="Selecione a sua concessionária"
                handleChange={handleConcessionariaChange}
                options={concessionariasMunicipio}
                wl={props.wl}
              />
            }
          />
        )}

        <input
          type="hidden"
          name="concessionaria"
          value={selectedConcessionaria?.id || ""}
        />

        <InputCard
          title="Quanto você gasta com luz por mês?"
          id="money"
          name="money"
          placeholder="Digite o valor gasto"
          value={formatBRL(formData?.valorConta)}
          wl={props.wl}
          onChange={(event) => {
            const onlyNumbers = event.target.value.replace(/\D/g, "");
            const valorConsumo =
              onlyNumbers.length > 2 ? onlyNumbers.slice(0, -2) : "0";

            setFormData((prev) => ({
              ...prev,
              valorConsumo,
              valorConta: onlyNumbers,
            }));

            configSimulacao({
              setFormData,
              formData: {
                ...formData,
                valorConsumo,
                valorConta: onlyNumbers,
              },
              concessionariaId: selectedConcessionaria?.id,
            });
          }}
        />

        {errorMessage ? (
          <div className={`msg__error__icon__alert ${styles["msg-error"]}`}>
            <img src="/images/icons/notifications/alert-cicle.svg"></img>
            <span className="error">{errorMessage}</span>
          </div>
        ) : (
          ""
        )}

        <input
          type={"text"}
          id="tipoConta"
          name="tipoConta"
          defaultValue={formData?.selectedTypeButton?.selected ?? ""}
          required
          style={{ display: "none" }}
        />
        <input
          type="hidden"
          name="pessoaFisica"
          defaultValue={
            formData?.selectedTypeButton?.selected === "pf" ? "Sim" : "Não"
          }
        />
        <input
          type="hidden"
          name="pessoaJuridica"
          defaultValue={
            formData?.selectedTypeButton?.selected === "pj" ? "Sim" : "Não"
          }
        />

        {!formData?.dataDiscount?.status ? (
          getResultFailMessage(formData?.dataDiscount?.message)
        ) : (
          <>
            <section className={styles["calc-economia"]}>
              <span>
                <IconPercent />
              </span>
              <span className={styles["calc-economia-text"]}>
                <p>Você pode economizar até</p>
                <p>
                  <span className={styles["calc-economia-valor"]} style={{ color: props.wl?.cor_tema_primaria }}>
                    {new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    }).format(formData?.dataDiscount?.valorDescontoAnual)}
                  </span>
                  {" "}/ano
                </p>
              </span>
            </section>
          </>
        )}

        {selectedConcessionaria && dadosCalculoCo2.co2 > 0 && dadosCalculoCo2.arvores > 0 && formData?.dataDiscount?.status && (
          <section className={styles["calc-co2"]}>
            <span>
              <IconCo2  />
            </span>
            <span className={styles["calc-co2-text"]}>
              <p>Cerca de <span style={{ color: props.wl?.cor_tema_primaria }}>{parseInt(dadosCalculoCo2.co2)}</span> kg de CO2 neutralizados.</p>
              <p>Equivalente ao plantio de <span style={{ color: props.wl?.cor_tema_primaria }}>{Number(dadosCalculoCo2.arvores)}</span> {Number(dadosCalculoCo2.arvores) > 1 ? "árvores" : "árvore"} por ano.</p>
            </span>
          </section>
        )}
        <Button
          name={
            !formData?.dataDiscount?.status
              ? "Simular economia"
              : "Quero saber mais"
          }
          isDisable={
            submitButtonChildren != "Simular economia" ||
            !formData?.dataDiscount?.status
          }
          type="submit"
          className={styles["submit-button"]}
          style={bgSubmitButton}
          wl={props.wl}
        />
        <div className={styles["text-privacy-policy"]} >
          <>
            <span className={styles.justifyText}>
              Ao prosseguir você estará aceitando os {' '}
              <a>
                <ModalTitleText
                  src-icon-close={"/images/icons/button/close-white.svg"}
                  content={lang("usuario/index.termos-uso", "")}
                  isApp={props.isApp}
                />
              </a>
               {' '} e a {' '}
              <a>
                <ModalTitleText
                  src-icon-close={"/images/icons/button/close-white.svg"}
                  content={lang("usuario/index.politica-privacidade", "")}
                  isApp={props.isApp}
                />
              </a>
            {' '}da Electy.
            </span>
          </>
        </div>
      </form>
    </>
  );
};

export default Iframe;
